
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcDiodes as ObcDiodesElement} from '@oicl/openbridge-webcomponents/dist/automation/diodes/diodes.js';
 
 
 

 
 export const ObcDiodes = createComponent({
   react: React,
   tagName: 'obc-diodes',
   elementClass: ObcDiodesElement,
   events: {
     
   }
  });
 
 